$(() => {
	$("[data-selector]").each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "selector" */ "./index"
		);
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/selector/index--split.js